
<template>
    <div class="subscribeFooter">
        <div class="btn-container">
            <rich-button @click="joinSubscribe">
                {{ $t('FoodC_V2_NigJ_XaWd', {didipackbrand: brandName}) }}
            </rich-button>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'SubscribeFooter',
    computed: {
    ...mapState(['brandName']),
    },
    methods: {
        joinSubscribe() {
            this.$emit('joinSubscribe')
        },
    }

}
</script>
<style lang="scss" scoped>
.subscribeFooter {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 8;
    width: 100%;
    background: #ffffff;
    padding: 36px 24px 45px 24px;
    box-sizing: border-box;
    border-radius: 40px 40px 0 0;
    box-shadow: 0px -10px 48px 0px rgba(0,0,0,0.06);
    .rich-btn {
        height: 108px;
    }
}
  
</style>